import { useMemo } from 'react';
import { useGetAccountLevelMetadataEnabledQuery } from '@frameio/graphql-client/generated';
import { useActiveAccountId } from '@frameio/shared/contexts';
import { useAccountCustomFieldsLimit } from '@frameio/shared/fields/hooks';

export type FieldValidation = {
  availableCustomFieldCount: number;
};

/**
 * Validates whether a template can be used based on field limits.
 */
export const useTemplateFieldValidation = (): FieldValidation => {
  const accountId = useActiveAccountId();

  const { data: almEnabledData } = useGetAccountLevelMetadataEnabledQuery({
    variables: { accountId },
    skip: !accountId,
  });

  const { availableCustomFieldCount } = useAccountCustomFieldsLimit();

  return useMemo(() => {
    const isALMEnabled =
      almEnabledData?.account?.useAccountScopedFieldDefinitions;

    if (!isALMEnabled) {
      return {
        availableCustomFieldCount: Infinity,
      };
    }

    return {
      availableCustomFieldCount,
    };
  }, [almEnabledData, availableCustomFieldCount]);
};
